export const fiscalSettings = {
	form: {
		title: "Datos fiscales de Cover '{{name}}'",
		subtitle: "Actualizar datos fiscales de '{{name}}'",
		code: "SKU",
		ncm: "NCM",
		cest: "CEST",
		fiscalProfile: "Perfil fiscal",
		fiscalGroup: "Grupo fiscal",
		optionalFields:
			"Estos campos son opcionales, pero son necesarios para la emisión de facturas",
		onlyNumbers: "Solo números",
		cst: "CST",
		quantitySold: "Cantidad vendida",
		aliquota: "Alícuota",
		calculo: "Base de Cálculo",
		invoice: "Factura",
		service: "Servicio",
		vat: "Value-added tax",
		valueAdded: "Value-added",
		type: "Tipo",
		name: "Nombre",
		cfop: "CFOP",
		csosn: "CSOSN",
		origin: "Origen",
		reduceCalculo: "Reducción en la base de cálculo",
		servideCode: "Código de servicio",
		tributacao: "Código de tributación del municipio",
		generalFields: "Campos generales",
		icms: "ICMS",
		pis: "PIS",
		cofins: "COFINS",
		requiredField: "Este campo es obligatorio",
		createProfile: "Crear perfil fiscal",
		updateProfile: "Actualizar perfil fiscal",
		generalData: "Datos Generales",
		companyData: "Datos de la Empresa",
		cnpj: "RFC",
		inscricaoEstadual: "Registro Estatal",
		fantasyName: "Nombre Comercial",
		socialName: "Razón Social",
		regimeTributario: "Régimen Tributario",
		cityCode: "Código del Municipio",
		municipalRegistration: "Registro Municipal",
		address: "Dirección",
		zipCode: "Código postal",
		street: "Calle",
		number: "Número",
		adjunct: "Complemento",
		neighborhood: "Colonia",
		city: "Municipio",
		state: "Estado",
		contact: "Contacto",
		email: "Email",
		phone: "Teléfono",
		fiscal: "Fiscal",
		fiscalMode: "Modo fiscal",
		sat: "SAT-e",
		satNumber: "Número de Serie SAT",
		nfce: "NFC-e",
		certificate: "Certificado",
		certificatePassword: "Número del certificado",
		expirationDate: "Fecha de expiración",
		cscHomologation: "CSC NFC-e Homologación",
		idHomologation: "ID NFC-e Homologación",
		cscProduction: "CSC NFC-e Producción",
		idProduction: "ID NFC-e Producción",
		zipCodeValidation: "El código postal debe tener 8 números",
	},
	emptyData: "No existen datos para mostrar.",
	fiscalDataPlace: "Datos fiscales de Cover del Local",
	unavailable: "No disponible",
	fiscalGroupProduct: "Grupos fiscales de productos",
	addNewGroup: "Agregar nuevo grupo",
	addNewProfile: "Agregar nuevo perfil",
	delete: "¿Está seguro que desea eliminar?",
	expireIn: "Expira en",
	generalSettings: "Configuraciones Fiscales",
	searchFiscalProfile: "Buscar perfiles fiscales",
	searchFiscalGroup: "Buscar grupos fiscales",
};
